import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import ModalWrapper from './ModalWrapper';
import ModalWrapperBranched from '../ModalWrapper.modals_match_theme';
export default withFeatureBranch({
    modals_match_theme: ModalWrapperBranched
})(ModalWrapper);
